
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/artikel/mehrwert-einer-guten-datenueberwachungsschnittstelle",
      function () {
        return require("private-next-pages/[locale]/artikel/mehrwert-einer-guten-datenueberwachungsschnittstelle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/artikel/mehrwert-einer-guten-datenueberwachungsschnittstelle"])
      });
    }
  